import Cover from './Cover.view';

export default Cover;
